// extracted by mini-css-extract-plugin
export var contentBody = "_4t-9";
export var headerImage = "_4t-2";
export var imageButton = "_4t-7";
export var imageButtonIcon = "_4t-8";
export var imageHeader = "_4t-4";
export var imageHeaderText = "_4t-5";
export var imageOverlay = "_4t-3";
export var imageTitle = "_4t-6";
export var imageWrapper = "_4t-1";
export var taskList = "_4t-a";
export var widget = "_4t-0";